export function translator(word, lang) {
    return dictionary[word][lang]
}

const dictionary = {
    'Назад': {
        'ru': 'Назад',
        'en': 'Back'
    },
    'Цена': {
        'ru': 'Цена',
        'en': 'Price'
    },
    'Фильтры': {
        'ru': 'Фильтры',
        'en': 'Filters'
    },
    'Поле': {
        'ru': 'Поле',
        'en': 'Field'
    },
    'Вы не выбрали билет': {
        'ru': 'Вы не выбрали билет',
        'en': 'You have not selected a ticket'
    },
    'Выберите билет': {
        'ru': 'Выберите билет',
        'en': 'Choose a ticket'
    },
    'Парковка': {
        'ru': 'Парковка',
        'en': 'Parking'
    },
    'Cумма': {
        'ru': 'Cумма',
        'en': 'Amount'
    },
    'Дополнительно': {
        'ru': 'Дополнительно',
        'en': 'Additionally'
    },
    'Списать доступные бонусы': {
        'ru': 'Списать доступные бонусы',
        'en': 'Write off available bonuses'
    },
    'из': {
        'ru': 'из',
        'en': 'out of'
    },
    'Итого': {
        'ru': 'Итого',
        'en': 'Total'
    },
    'баллов': {
        'ru': 'баллов',
        'en': 'points'
    },
    'Войдите в личный кабинет, чтобы использовать баллы': {
        'ru': 'Войдите в личный кабинет, чтобы использовать баллы',
        'en': 'Log in to your account to redeem your points'
    },
    'Войти': {
        'ru': 'Войти',
        'en': 'Log in'
    },
    'Продолжить': {
        'ru': 'Продолжить',
        'en': 'Continue'
    },
    'Контактная информация': {
        'ru': 'Контактная информация',
        'en': 'Contact information'
    },
    'Электронная почта': {
        'ru': 'Электронная почта',
        'en': 'Email'
    },
    'Ваша электронная почта': {
        'ru': 'Ваша электронная почта',
        'en': 'Your email'
    },
    'Введите код из E-mail': {
        'ru': 'Введите код из E-mail',
        'en': 'Enter code from E-mail'
    },
    'Код подтверждения': {
        'ru': 'Код подтверждения',
        'en': 'Confirmation code'
    },
    'Купить': {
        'ru': 'Купить',
        'en': 'Buy'
    },
    'Нажимая на кнопку "Купить" вы соглашаетесь с': {
        'ru': 'Нажимая на кнопку "Купить" вы соглашаетесь с',
        'en': 'By clicking on the "Buy" button, you agree to'
    },
    'политикой конфиденциальности и условиями покупки': {
        'ru': 'политикой конфиденциальности и условиями покупки',
        'en': 'privacy policy and terms of purchase'
    },
    'Применить': {
        'ru': 'Применить',
        'en': 'Apply'
    },
    'продолжить': {
        'ru': 'продолжить',
        'en': 'proceed'
    },
    'Превышено ограничение': {
        'ru': 'Превышено ограничение',
        'en': 'Limit exceeded'
    },
    'Согласие на хранение и обработку персональных данных': {
        'ru': 'Согласие на хранение и обработку персональных данных',
        'en': 'Consent to the storage and processing of personal data'
    },
    'Настоящим я подтверждаю достоверность указанных данных, ознакомление с Правилами поведения зрителей при проведении домашних матчей ПФК «Крылья Советов», соблюдение указанных Правил и обязуюсь их выполнять, в том числе нести предусмотренную ими ответственность. Правила размещены на сайте pfcks.ru. Разрешаю ЗАО ПФК «Крылья Советов» (адрес: 443011, г.Самара, ул.Шушенская, д.50 «А», ИНН 6312039565) и ФПРФ СО (адрес: 443011, г.Самара, ул.Шушенская, д.50 «А», ИНН 6312997744), а также третьим лицам осуществлять смешанную обработку, как автоматизированную, так и не автоматизированную, всех данных, указанных в настоящей анкете, включая сбор, систематизацию, накопление, хранение, уточнение, использование, передачу (в т.ч. трансграничную передачу), обезличивание, уничтожение персональных данных в целях реализации ЗАО ПФК «Крылья Советов» прав по не допуску нарушителей Правил на матчи ПФК «Крылья Советов», а также связанных с возможностью предоставления информации о товарах и услугах, которые потенциально могут предоставлять для меня интерес, новостной и рекламной информации от ПФК «Крылья Советов» и его партнеров, а также в целях сбора и обработки статистической информации и проведения маркетинговых исследований. Согласие на обработку персональных данных в соответствии с указанными выше условиями я предоставляю бессрочно. Я уведомлен и согласен с тем, что указанное согласие может быть отозвано мной посредством письменного заявления, направленного заказным почтовым отправлением с описью вложения либо врученного лично под роспись уполномоченному представителю по адресу: 443011, г.Самара, ул.Шушенская, д.50 «А». Я подтверждаю, что даю свое согласие на информирование меня посредством СМС-сообщений и электронных писем на указанный мной в данной анкете номер телефона и адрес электронной почты о рекламных и (или) маркетинговых акциях ЗАО ПФК «Крылья Советов» и (или) его партнеров.':
        {
            'ru': 'Настоящим я подтверждаю достоверность указанных данных, ознакомление с Правилами поведения зрителей при проведении домашних матчей ПФК «Крылья Советов», соблюдение указанных Правил и обязуюсь их выполнять, в том числе нести предусмотренную ими ответственность. Правила размещены на сайте pfcks.ru. Разрешаю ЗАО ПФК «Крылья Советов» (адрес: 443011, г.Самара, ул.Шушенская, д.50 «А», ИНН 6312039565) и ФПРФ СО (адрес: 443011, г.Самара, ул.Шушенская, д.50 «А», ИНН 6312997744), а также третьим лицам осуществлять смешанную обработку, как автоматизированную, так и не автоматизированную, всех данных, указанных в настоящей анкете, включая сбор, систематизацию, накопление, хранение, уточнение, использование, передачу (в т.ч. трансграничную передачу), обезличивание, уничтожение персональных данных в целях реализации ЗАО ПФК «Крылья Советов» прав по не допуску нарушителей Правил на матчи ПФК «Крылья Советов», а также связанных с возможностью предоставления информации о товарах и услугах, которые потенциально могут предоставлять для меня интерес, новостной и рекламной информации от ПФК «Крылья Советов» и его партнеров, а также в целях сбора и обработки статистической информации и проведения маркетинговых исследований. Согласие на обработку персональных данных в соответствии с указанными выше условиями я предоставляю бессрочно. Я уведомлен и согласен с тем, что указанное согласие может быть отозвано мной посредством письменного заявления, направленного заказным почтовым отправлением с описью вложения либо врученного лично под роспись уполномоченному представителю по адресу: 443011, г.Самара, ул.Шушенская, д.50 «А». Я подтверждаю, что даю свое согласие на информирование меня посредством СМС-сообщений и электронных писем на указанный мной в данной анкете номер телефона и адрес электронной почты о рекламных и (или) маркетинговых акциях ЗАО ПФК «Крылья Советов» и (или) его партнеров.',
            'en': 'I hereby confirm the accuracy of the specified data, familiarization with the Rules of Behavior for Spectators during Home Matches of PFC Krylya Sovetov, compliance with these Rules and undertake to comply with them, including bear the responsibility stipulated by them. The rules are posted on the website pfcks.ru. I authorize CJSC PFC “Krylya Sovetov” (address: 443011, Samara, Shushenskaya st., 50 “A”, TIN 6312039565) and FPRF SO (address: 443011, Samara, Shushenskaya st., 50 “ A”, TIN 6312997744), as well as to third parties to carry out mixed processing, both automated and non-automated, of all data specified in this questionnaire, including collection, systematization, accumulation, storage, clarification, use, transfer (including cross-border transfer), depersonalization, destruction of personal data in order to exercise the rights of CJSC PFC Krylya Sovetov to prevent violators of the Rules from attending the matches of PFC Krylya Sovetov, as well as related to the possibility of providing information about goods and services that can potentially provide for I am interested in news and advertising information from PFC "Wings of the Soviets" and its partners, as well as for the purpose of collecting and processing statistical information and conducting marketing research. Consent to the processing of personal data in accordance with the above conditions, I provide indefinitely. I have been notified and agree that this consent may be withdrawn by me by means of a written statement sent by registered mail with a list of attachments or delivered personally against signature to an authorized representative at the address: 443011, Samara, Shushenskaya st., 50 "A ". I confirm that I give my consent to informing me via SMS messages and e-mails to the phone number and e-mail address indicated by me in this questionnaire about advertising and (or) marketing promotions of CJSC PFC Krylya Sovetov and (or) its partners.'
        },
    'Уважаемые болельщики! В настоящее время уполномоченными органами рассматривается вопрос о введении обязательной идентификации и аутентификации зрителей (Fan ID) при проведении соревнований, в которых участвует Клуб. Обращаем Ваше внимание, что в случае принятия соответствующего решения, посещение матчей клуба будет возможно исключительно при прохождении болельщиком обязательной идентификации и аутентификации, в т.ч. при предъявлении действующей персонифицированной карты.': {
        'ru': 'Уважаемые болельщики! В настоящее время уполномоченными органами рассматривается вопрос о введении обязательной идентификации и аутентификации зрителей (Fan ID) при проведении соревнований, в которых участвует Клуб. Обращаем Ваше внимание, что в случае принятия соответствующего решения, посещение матчей клуба будет возможно исключительно при прохождении болельщиком обязательной идентификации и аутентификации, в т.ч. при предъявлении действующей персонифицированной карты.',
        'en': 'Dear fans! Currently, the authorized bodies are considering the introduction of mandatory identification and authentication of spectators (Fan ID) during competitions in which the Club participates. Please note that if a relevant decision is made, visiting the club\'s matches will be possible only if the fan passes the mandatory identification and authentication, incl. upon presentation of a valid personalized card.'
    },
    'Выберите паркинг': {
        'ru': 'Выберите паркинг',
        'en': 'Choose a parking'
    },
    'Ой, произошла ошибка': {
        'ru': 'Ой, произошла ошибка',
        'en': 'Oops, there was an error'
    },
    'Попробуйте ещё раз': {
        'ru': 'Попробуйте ещё раз',
        'en': 'Try again'
    },
    'Билет оплачен, можете отправить его на почту,': {
        'ru': 'Билет оплачен, можете отправить его на почту,',
        'en': 'The ticket is paid, you can send it to the email,'
    },
    'или сохранить на устройстве': {
        'ru': 'или сохранить на устройстве',
        'en': 'or save to device'
    },
    'Отправить на почту': {
        'ru': 'Отправить на почту',
        'en': 'Send to email'
    },
    'Сохранить билет': {
        'ru': 'Сохранить билет',
        'en': 'Save ticket'
    },
    'Вернуться на главную': {
        'ru': 'Вернуться на главную',
        'en': 'Go back to the main page'
    },
    'Куда вам отправить билет': {
        'ru': 'Куда вам отправить билет',
        'en': 'Where to send your ticket'
    },
    'Отправить': {
        'ru': 'Отправить',
        'en': 'Send'
    },
    'Заказ оформлен': {
        'ru': 'Заказ оформлен',
        'en': 'Order is processed'
    },
    'На главную': {
        'ru': 'На главную',
        'en': 'To main'
    },
    'Ошибка': {
        'ru': 'Ошибка',
        'en': 'Error'
    },
    'Повторить': {
        'ru': 'Повторить',
        'en': 'Repeat'
    },
    'Выберите сектор': {
        'ru': 'Выберите сектор',
        'en': 'Choose sector'
    },
    'Сектор': {
        'ru': 'Сектор',
        'en': 'Sector'
    },
    'сектор': {
        'ru': 'сектор',
        'en': 'sector'
    },
    'блок': {
        'ru': 'блок',
        'en': 'unit'
    },
    'свободно': {
        'ru': 'свободно',
        'en': 'free'
    },
    'К продаже доступно максимум 4 абонемента для одного пользователя': {
        'ru': 'К продаже доступно максимум 4 абонемента для одного пользователя',
        'en': 'A maximum of 4 subscriptions per user are available for sale'
    },
    'К продаже доступно максимум ': {
        'ru': 'К продаже доступно максимум ',
        'en': 'A maximum of '
    },
    ' для одного пользователя': {
        'ru': ' для одного пользователя',
        'en': ' per user are available for sale'
    },
    'абонемент': {
        'ru': 'абонемент',
        'en': 'subscription'
    },
    'абонемента': {
        'ru': 'абонемента',
        'en': 'subscriptions'
    },
    'абонементов': {
        'ru': 'абонементов',
        'en': 'subscriptions'
    },
    'На данное мероприятие нет возможности приобрести больше 20‑ти билетов': {
        'ru': 'На данное мероприятие нет возможности приобрести больше 20‑ти билетов',
        'en': 'It is not possible to purchase more than 20 tickets for this event'
    },
    'цена билета': {
        'ru': 'цена билета',
        'en': 'ticket price'
    },
    'Ряд': {
        'ru': 'Ряд',
        'en': 'Row'
    },
    'место': {
        'ru': 'место',
        'en': 'seat'
    },
    'На данное мероприятие нет возможности приобрести больше 20 билетов на 1 человека': {
        'ru': 'На данное мероприятие нет возможности приобрести больше 20 билетов на 1 человека',
        'en': 'It is not possible to purchase more than 20 tickets for 1 person for this event'
    },
    'Выбрать другой матч': {
        'ru': 'Выбрать другой матч',
        'en': 'Choose another match'
    },
    'Уважаемый болельщик!': {
        'ru': 'Уважаемый болельщик!',
        'en': 'Dear fan!'
    },
    'В период с 1.06 по 15.06 у вас есть возможность приоритетного права покупки абонемента на сезон 2022/2023 гг по специальной цене. Допустима продажа до 4-х сезонных билетов на одну учетную регистрационную запись с указанием информации о владельце сезонного абонемента.': {
        'ru': 'В период с 1.06 по 15.06 у вас есть возможность приоритетного права покупки абонемента на сезон 2022/2023 гг по специальной цене. Допустима продажа до 4-х сезонных билетов на одну учетную регистрационную запись с указанием информации о владельце сезонного абонемента.',
        'en': 'In the period from 01.06 to 15.06 you have the option of priority right to purchase a season ticket for the 2022/2023 season at a special price. It is allowed to sell up to 4 season tickets per registration account with information about the owner of the season ticket.'
    },
    'В настоящее время покупка абонементов на сезон 2022-2023 доступна только для держателей абонемента сезона 2021-2022. Вы сможете приобрести абонемент с 16.06.2022г. на официальном сайте клуба и клубных магазинах в ТЦ "Сила Спорта" и СК "Металлург".Если вы являетесь держателем абонемента на сезон 2021-2022, но вам не доступна покупка абонемента обратитесь к администратору билетной системы по тел.': {
        'ru': 'В настоящее время покупка абонементов на сезон 2022-2023 доступна только для держателей абонемента сезона 2021-2022. Вы сможете приобрести абонемент с 16.06.2022г. на официальном сайте клуба и клубных магазинах в ТЦ "Сила Спорта" и СК "Металлург".Если вы являетесь держателем абонемента на сезон 2021-2022, но вам не доступна покупка абонемента обратитесь к администратору билетной системы по тел.',
        'en': 'The purchase of season tickets for the 2022-2023 season is currently only available to season ticket holders for the 2021-2022 season. You will be able to purchase a subscription from 06/16/2022. on the official website of the club and club stores in the shopping center "Power of Sport" and SC "Metallurg". If you are a season ticket holder for the 2021-2022 season, but the purchase of a season ticket is not available to you, contact the ticket system administrator at tel.'
    },
    'Ошибка инициализации': {
        'ru': 'Ошибка инициализации',
        'en': 'Initialization error'
    },
    'Сектор недоступен, выберите другой': {
        'ru': 'Сектор недоступен, выберите другой',
        'en': 'Sector not available, select another'
    },
    'Ошибка обработки данных, попробуйте еще раз': {
        'ru': 'Ошибка обработки данных, попробуйте еще раз',
        'en': 'Data processing error, please try again'
    },
    'Не удалось оформить билет': {
        'ru': 'Не удалось оформить билет',
        'en': 'Failed to issue a ticket'
    },
    'Ошибка обработки платежа': {
        'ru': 'Ошибка обработки платежа',
        'en': 'Payment processing error'
    },
    'Блок': {
        'ru': 'Блок',
        'en': 'Unit'
    },
    'Место': {
        'ru': 'Место',
        'en': 'Seat'
    },
    'Карта болельщика': {
        'ru': 'Карта болельщика',
        'en': 'Fan card'
    },
    'Введите номер карты болельщика': {
        'ru': 'Введите номер карты болельщика',
        'en': 'Enter fan id card number'
    },
    '№ карты болельщика': {
        'ru': '№ карты болельщика',
        'en': 'Fan card number'
    },
    'К сожалению, данное место уже забронировано, выберите другое': {
        'ru': 'К сожалению, данное место уже забронировано, выберите другое',
        'en': 'Sorry, this place is already booked, please choose another'
    },
    'Выбрать место': {
        'ru': 'Выбрать место',
        'en': 'Choose a place'
    },
    'Информация не найдена или введена не корректно.': {
        'ru': 'Информация не найдена или введена не корректно.',
        'en': 'Information not found or entered incorrectly.'
    },
    'Пример': {
        'ru': 'Пример',
        'en': 'Example'
    },
    '№ карты болельщика: 123456789 (9 символов)': {
        'ru': '№ карты болельщика: 123456789 (9 символов)',
        'en': 'Fan card number: 123456789 (9 characters)'
    },
    'Телефон': {
        'ru': 'Телефон',
        'en': 'Phone'
    },
    'Попробовать ещё раз': {
        'ru': 'Попробовать ещё раз',
        'en': 'Try again'
    },
    'Оформить карту болельщика': {
        'ru': 'Оформить карту болельщика',
        'en': 'Get a fan card'
    },
    'Выбрано': {
        'ru': 'Выбрано',
        'en': 'Selected'
    },
    'Фамилия': {
        'ru': 'Фамилия',
        'en': 'Surname'
    },
    'Ваша фамилия': {
        'ru': 'Ваша фамилия',
        'en': 'Your surname'
    },
    'Имя': {
        'ru': 'Имя',
        'en': 'Firstname'
    },
    'Ваше имя': {
        'ru': 'Ваше имя',
        'en': 'Your firstname'
    },
    'Оформление заказа': {
        'ru': 'Оформление заказа',
        'en': 'Checkout'
    },
    'Отправить повторно через': {
        'ru': 'Отправить повторно через',
        'en': 'Resend via'
    },
    'сек': {
        'ru': 'сек',
        'en': 'sec'
    },
    'Отправить повторно': {
        'ru': 'Отправить повторно',
        'en': 'Resend'
    },
    'Введен неверный код': {
        'ru': 'Введен неверный код',
        'en': 'Invalid code entered'
    },
    'Минимум 6 цифр': {
        'ru': 'Минимум 6 цифр',
        'en': 'Minimum 6 digits'
    },
    'Нет свободных мест': {
        'ru': 'Нет свободных мест',
        'en': 'No free places'
    },
    'Недоступен для продажи': {
        'ru': 'Недоступен для продажи',
        'en': 'Not available for sale'
    },
    'Вы не авторизованы': {
        'ru': 'Вы не авторизованы',
        'en': 'You are not authorized'
    },
    'Введите:': {
        'ru': 'Введите:',
        'en': 'Enter:'
    },
    'Номер телефона в формате 7хххххххххх, без пробелов и других символов. Необходимо указать телефон, привязанный к личному кабинету болельщика на сайте': {
        'ru': 'Номер телефона в формате 7хххххххххх, без пробелов и других символов. Необходимо указать телефон, привязанный к личному кабинету болельщика на сайте',
        'en': 'Phone number in the format 7ххххххххх, without spaces or other symbols. You must specify the phone number linked to the fan\'s personal account on the website'
    },
    'ИЛИ': {
        'ru': 'ИЛИ',
        'en': 'OR'
    },
    'Адрес электронной почты в формате name@domain.name. Необходимо указать адрес почты, привязанной к личному кабинету болельщика на сайте ': {
        'ru': 'Адрес электронной почты в формате name@domain.name. Необходимо указать адрес почты, привязанной к личному кабинету болельщика на сайте ',
        'en': 'Email address in the format name@domain.name. You must specify the email address associated with the fan\'s personal account on the website '
    },
    '№ карты болельщика в формате 123456789 (9 символов). Карту болельщика можно оформить в личном кабинете на сайте': {
        'ru': '№ карты болельщика в формате 123456789 (9 символов). Карту болельщика можно оформить в личном кабинете на сайте',
        'en': 'Fan card number in the format 123456789 (9 characters). A fan card can be issued in your personal' +
            ' account on the website'
    },
    'Госуслуги': {
        'ru': 'Госуслуги',
        'en': 'Gosuslugi'
    },
    'Если вы указали все верно, но появляется ошибка - ': {
        'ru': 'Если вы указали все верно, но появляется ошибка - ',
        'en': 'If you entered everything correctly, but an error appears - '
    },
    'Если вы указали все верно, но появляется ошибка - напишите на ': {
        'ru': 'Если вы указали все верно, но появляется ошибка - напишите на ',
        'en': 'If you entered everything correctly, but an error appears - write to '
    },
    'Покупка абонемента для вас недоступна, так как вами уже был приобретён абонемент': {
        'ru': 'Покупка абонемента для вас недоступна, так как вами уже был приобретён абонемент',
        'en': 'The purchase of a subscription is not available for you, since you have already purchased a subscription'
    },
    'гостевой сектор Краснодар': {
        'ru': 'гостевой сектор Краснодар',
        'en': 'guest sector Krasnodar',
    },
    'СЕКТОР ЦСКА': {
        'ru': 'СЕКТОР ЦСКА',
        'en': 'SECTOR CSKA',
    },
    'Время ожидания выбора мест истекло':{
        'ru':'Время ожидания выбора мест истекло',
        'en': 'Seat selection timed out',
    },
    'Пожалуйста, обновите страницу': {
        'ru': 'Пожалуйста, обновите страницу',
        'en': 'Please refresh the page'
    },
    'Обновить страницу': {
        'ru': 'Обновить страницу',
        'en': 'Refresh the page'
    },
    'На оплату заказа осталось:': {
        'ru': 'На оплату заказа осталось:',
        'en': 'Left to pay for the order:'
    },
    'Время вышло': {
        'ru': 'Время вышло',
        'en': 'Time is over'
    },
    'Время на покупку билетов вышло.<br>Чтобы продолжить, перезагрузите страницу': {
        'ru': 'Время на покупку билетов вышло.<br>Чтобы продолжить, перезагрузите страницу',
        'en': 'The time to purchase tickets has expired.<br>To continue, reload the page'
    },
    'Перезагрузить страницу': {
        'ru': 'Перезагрузить страницу',
        'en': 'Reload page'
    },
    'Введите промокод':{
        'ru': 'Введите промокод',
        'en': 'Enter promo code'
    },
    'Промокод':{
        'ru': 'Промокод',
        'en': 'Promo code'
    },
    'Данное мероприятие уже состоялось.':{
        'ru': 'Данное мероприятие уже состоялось.',
        'en': 'This event has already taken place.'
    },
    'Выберите другой матч.': {
        'ru': 'Выберите другой матч.',
        'en': 'Choose a different match.'
    },
    'Извините, похоже какое то место в заказе не доступно для покупки':{
        'ru': 'Извините, похоже какое то место в заказе не доступно для покупки',
        'en': 'Sorry, it looks like some place in the order is not available for purchase'
    },
    'Выбрать другое место':{
        'ru':'Выбрать другое место',
        'en': 'Choose another seat'
    },
    'ДИНАМО ГОСТЕВОЙ':{
        'ru': 'ДИНАМО ГОСТЕВОЙ',
        'en': 'DYNAMO GUEST'
    },
    'Оформить заказ':{
        'ru': 'Оформить заказ',
        'en': 'Checkout'
    },
    'Билет на матч':{
        'ru': 'Билет на матч',
        'en': 'Match ticket'
    },
    'Абонемент':{
        'ru': 'Абонемент',
        'en': 'Subscription'
    },
    'Ошибка применения промокода':{
        'ru':'Ошибка применения промокода',
        'en':'Promo code application error'
    },
    'Ошибка расчёта цены для товара':{
        'ru':'Ошибка расчёта цены для товара',
        'en':'Error in calculating the price for the product'
    },
    'Ошибка расчёта цены для заказа':{
        'ru':'Ошибка расчёта цены для заказа',
        'en':'Error in calculating the price for the order'
    },
    'В настоящее время покупка доступна только для владельцев абонементов на сезон 2022/2023. Покупка абонемента для Вас будет доступна с 19.06.2023.':{
        'ru': 'В настоящее время покупка доступна только для владельцев абонементов на сезон 2023/2024. Покупка абонемента для Вас будет доступна с 17.07.2024.',
        'en': 'Purchase is currently only available to season ticket holders for the 2023/2024 season. The purchase of a subscription will be available for you from 07/17/2024.'
    },
    'СЕЗОННЫЙ БИЛЕТ':{
        'ru':'СЕЗОННЫЙ БИЛЕТ',
        'en':'SEASON TICKET'
    },
}
